import type { Namespace, TFunction } from 'i18next';

import type { FrontendI18nKey } from '~/shared/types/i18n-type';
import { DEFAULT_LOCALE, LOCALES, type NameSpace } from '~/universal/constants';

export const getTypedT = <Ns extends Namespace>(t: TFunction<Ns>) => {
  return (key: FrontendI18nKey, options?: Record<string, unknown>) => {
    const [ns] = key.split('.');

    // @ts-expect-error
    return t(key, {
      ...options,
      ns: ns as NameSpace,
    });
  };
};

export const getLocaleFromPathname = (pathname?: string | null) => {
  if (!pathname) {
    return DEFAULT_LOCALE;
  }

  if (pathname === '/ru' || pathname.startsWith('/ru/')) {
    return LOCALES.RU;
  }

  if (pathname === '/en' || pathname.startsWith('/en/')) {
    return LOCALES.EN;
  }

  return LOCALES.UA;
};
